import "./ExcalidrawLogo.scss";

const LogoIcon = () => (
  <img
    src="https://meethour.io/img/logo/logo.svg"
    alt="Meethour Whiteboard"
    style={{
      width: "450px",
    }}
    className="ExcalidrawLogo-icon"
  />
);

// const LogoText = () => (
//   <img
//     src="https://meethour.io/img/logo/logo.svg"
//     alt="Meethour Whiteboard"
//     style={{
//       width: "450px",
//     }}
//     className="ExcalidrawLogo-text"
//   />
// );

type LogoSize = "xs" | "small" | "normal" | "large" | "custom";

interface LogoProps {
  size?: LogoSize;
  withText?: boolean;
  style?: React.CSSProperties;
  /**
   * If true, the logo will not be wrapped in a Link component.
   * The link prop will be ignored as well.
   * It will merely be a plain div.
   */
  isNotLink?: boolean;
}

export const ExcalidrawLogo = ({
  style,
  size = "small",
  withText,
}: LogoProps) => {
  return (
    <div className={`ExcalidrawLogo is-${size}`} style={style}>
      <LogoIcon />
      {/* {<LogoText />} */}
    </div>
  );
};
